<template>
  <div id="membersList">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="用户名">
          <el-input
            placeholder="请输入用户名"
            clearable
            v-model="formInline.Name"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            placeholder="请输入手机号"
            clearable
            v-model="formInline.MobilePhone"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="OpenId">
          <el-input
            placeholder="请输入OpenId"
            clearable
            v-model="formInline.OpenId"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width:98px"
            type="primary"
            @click="handleCurrentChange(1)"
          >查询用户</el-button>
          <el-button
            style="width:98px"
            type="danger"
            plain
            @click="reset"
          >重置</el-button>
        </el-form-item>
        <el-form-item
          label=""
          style="float:right"
        >
          <el-button
            style="width:128px"
            type="primary"
            @click="dialogVisible=true"
          >上传用户标签</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="userList"
        border
        style="width: 100%"
      >
        <el-table-column
          header-align="center"
          prop="name"
          label="用户名"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobilePhone"
          label="手机号"
          width="120"
        >
        </el-table-column>
        <el-table-column
          width="120"
          header-align="center"
          align="center"
          prop="openId"
          label="openId"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="developerName"
          label="发展专员"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="developerPhone"
          label="发展专员手机号"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enterpriseName"
          label="所属企业"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="parentName"
          label="所属合伙人"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="parentPhone"
          label="合伙人电话"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="received"
          width="120"
          label="已领取总额(元)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="unReceived"
          width="120"
          label="未领取余额(元)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="120"
          label="公众号状态"
        >
          <template slot-scope="scope">
            <span v-text="scope.row.isSubscribe?'已关注':'未关注'" :style="{color:scope.row.isSubscribe?'#67c23a':'#f56c6c'}" />
          </template>
        </el-table-column>
        <el-table-column prop="rolePermissions" label="角色权限" header-align="center" min-width="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.rolePermissions && Array.isArray(row.rolePermissions) && row.rolePermissions.length > 0">
              <div
                style="display:inline-block;padding: 3px 5px;margin: 3px;background-color: #e9e9eb;color: #909399;border-radius: 5px;"
                v-for="(item, index) in row.rolePermissions"
                :key="index">
                {{ item.roleName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              @click="openDes(scope.row)"
              size="mini"
              plain
            >
              详情
            </el-button>
            <el-button
              @click="openLabel(scope.row)"
              size="mini"
              plain
            >
              标签
            </el-button>
            <el-button
              @click="auth(scope.row)"
              size="mini"
              plain
            >
              设置权限
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination>
    </div>
     <el-dialog
      @close="close"
      title="上传用户标签信息"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        :on-success="success"
        :action="uploadUrl"
        :headers="{Authorization: accessToken}"
        :multiple="false"
        :auto-upload="false"
        :on-change="uploadChange"
        :on-remove="handleRemove"
        accept=".xls,.xlsx"
        :limit="1"
        :data="{
          name:'flie'}"
        :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div
          class="el-upload__tip"
          slot="tip"
        >只能上传xls和xlsx文件，<a href="javascript:void(0)" @click="dowloadTemp">点击下载模板</a></div>
      </el-upload>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="submitUpload"
        >确 定</el-button>
      </div>
    </el-dialog>
    <labelDialog
      v-if="dialogLabelVisible"
      :showLabel.sync="dialogLabelVisible"
      :desObj="desObj">
    </labelDialog>
    <membersRecordDialog
      v-if="dialogDesVisible"
      :showDes.sync="dialogDesVisible"
      :desObj="desObj">
    </membersRecordDialog>
    <authDialog ref="authDialog" @done="getUserList" />
  </div>
</template>

<script>
import { getUser, dowloadTagTemp } from 'api/request'
import { SetTableH } from '../../utils/utils'
import membersRecordDialog from './components/membersRecordDialog'
import labelDialog from './components/labelDialog'
import authDialog from "./components/authDialog";
export default {
  data() {
    return {
      dialogDesVisible: false,
      dialogLabelVisible:false,
      loading: true,
      tableH: '250',
      desObj: null,
      dialogVisible:false,
      uploadUrl: process.env.VUE_APP_BaseAPI + '/api/manager/tag/import',
      accessToken: 'Bearer ' + window.sessionStorage.getItem('token'),
      fileList: [],
      formInline: {
        Name: '',
        MobilePhone: '',
        OpenId: ''
      },
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10
      },
      userList: []
    }
  },
  components: { membersRecordDialog,labelDialog, authDialog },
  methods: {
    reset() {
      for (let key in this.formInline) {
        this.formInline[key] = ''
      }
      this.handleCurrentChange(1)
    },
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getUserList()
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      this.getUserList()
    },
    async getUserList() {
      let params = {
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
        Name: this.formInline.Name ? this.formInline.Name : null,
        MobilePhone: this.formInline.MobilePhone
          ? this.formInline.MobilePhone
          : null,
        OpenId: this.formInline.OpenId ? this.formInline.OpenId : null,
        AgentId:  sessionStorage.getItem('uId')
      }
      this.loading = true
      let data = await getUser(params)
      if (data) {
        this.userList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    openDes(data) {
      this.desObj = data
      this.dialogDesVisible = true
    },
    openLabel(data) {
      this.desObj = data
      this.dialogLabelVisible = true
    },
    // 弃用
    toRecord(id) {
      this.$router.push({
        path: '/membersRecord',
        query: { id: id }
      })
    },
    submitUpload() {
      if (this.fileList.length) {
        this.$refs.upload.submit()
      } else {
        this.$message({
          message: '请上传上传用户标签文件',
          type: 'warning'
        })
      }
    },
    success(response, file, fileList) {
      if (response.code === 200&&response.result) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.close()
        this.handleCurrentChange(1)
      } else {
        this.fileList = []
        this.$message.error('上传失败' + '，请重新上传')
      }
    },
    uploadChange(file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      this.fileList = []
    },
    close() {
      this.fileList = []
      this.dialogVisible = false
    },
    async dowloadTemp() {
      try {
        const data = await dowloadTagTemp()
        const blob = new Blob([data.data], { type: '.xlsx' }) // 构造一个blob对象来处理数据，并设置文件类型
        if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
          navigator.msSaveBlob(blob, '用户导入模板.xlsx')
        } else {
          const href = URL.createObjectURL(blob) // 创建新的URL表示指定的blob对象
          const a = document.createElement('a') // 创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = '用户导入模板.xlsx' // 指定下载文件名
          a.click() // 触发下载
          URL.revokeObjectURL(a.href) // 释放URL对象
        }
      } catch (e) {
        console.log(e)
      }
    },
    auth(data) {
      let temData = JSON.parse(JSON.stringify(data))
      temData.phone = data.mobilePhone
      temData.type = 2
      this.$refs.authDialog.show(temData)
    }
  },
  mounted() {
    SetTableH(this)
  },
  created() {
    this.getUserList()
  }
}
</script>
<style lang='scss'>
#membersList {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
  .dialog-footer {
    text-align: center;
  }
  .el-upload {
    display: block;
    margin: 0 auto;
    .el-upload-dragger {
      margin: 0 auto;
      width: 100%;
    }
  }
}
</style>
